import { ConsumerTrackingManagerV1Impl, GlobalTrackingManagerV1 } from './v1';
export const defineTrackingService = (options) => {
    const trackingService = new GlobalTrackingManagerV1(options.environmentData, options.provider, options.breakPoints, window, options.navigationDataFn);
    return {
        id: 'tracking',
        create() {
            return {
                '1.0.0': () => ({
                    featureService: new ConsumerTrackingManagerV1Impl(trackingService)
                })
            };
        }
    };
};
